import React from 'react';
import { useAuth } from 'react-oidc-context';
import logo from '../logo.png';

export function NavBar() {
  const auth = useAuth();
  const logoutFromCognito = () => {
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    const baseDomain = process.env.REACT_APP_COGNITO_BASE_DOMAIN;
    const region = process.env.REACT_APP_COGNITO_REGION;
    const postLogoutRedirectUri = window.location.origin;

    const logoutUrl = `https://${baseDomain}.auth.${region}.amazoncognito.com/logout?client_id=${clientId}&logout_uri=${postLogoutRedirectUri}`;
    auth.removeUser();
    window.location.href = logoutUrl;
  };

  return (
    <nav style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0.75rem 2rem',
      backgroundColor: '#712B1F',
      color: '#fff',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
      <img
        src={logo}
        alt="Bible Gateway"
        style={{
            height: '32px',
            padding: '4px',
            borderRadius: '6px',
            backgroundColor: '#fff'
        }}
    />
        <h1 style={{
          margin: 0,
          fontSize: '1.5rem',
          fontWeight: 600,
          fontFamily: 'Segoe UI, Inter, Roboto, sans-serif',
          letterSpacing: '0.5px'
        }}>
          Bible Gateway BgLookup
        </h1>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
      < span>{auth.user?.profile?.['cognito:username']}</span>
          <button onClick={logoutFromCognito} style={{
          padding: '0.4rem 0.8rem',
          backgroundColor: '#fff',
          color: '#712B1F',
          border: '1px solid #fff',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>
          Logout
        </button>
      </div>
    </nav>
  );
}
